const styles = {
  "indicator-icon": "_indicator-icon_133tf_26"
};
export {
  styles as default
};
//# sourceMappingURL=IndicatorIcon.module.css.js.map
